import type { SVGProps } from 'react'

/**
 * THIS FILE IS AUTO GENERATED!
 * Direct changes to this file will be overwritten on next icons:build execution.
 * Changes have to be made in the assets/*.svg file.
 * Afterwards execute the icons:build command.
 */
export const QuotationMark = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={32}
    height={32}
    viewBox="0 0 29 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M20.244 12.155a5.222 5.222 0 01-2.546-2.245c-.648-.981-.973-2.168-.973-3.562 0-1.858.574-3.38 1.722-4.567C19.595.594 21.017 0 22.715 0c1.796 0 3.269.594 4.417 1.78 1.147 1.188 1.721 2.71 1.721 4.568 0 .93-.1 1.833-.299 2.71-.25.877-.699 2.194-1.348 3.948L23.238 24H17.25l2.995-11.845zm-15.872 0A5.222 5.222 0 011.827 9.91c-.65-.981-.973-2.168-.973-3.562 0-1.858.573-3.38 1.721-4.567C3.723.594 5.145 0 6.843 0c1.797 0 3.269.594 4.417 1.78 1.148 1.188 1.722 2.71 1.722 4.568 0 .93-.1 1.833-.3 2.71-.25.877-.698 2.194-1.347 3.948L7.367 24h-5.99l2.995-11.845z"
      fill="currentColor"
    />
  </svg>
)
